import { object, string, number, collection, date } from '@gogame/schemas';

import {
  NAME,
  NUMBER,
  APPLICATION,
  START_DATE,
  PROMO_CODE,
  REWARDS,
  ACTIVITY_TYPE,
  REQUESTED_BY,
  JIRA_LINK,
  CONDITIONAL_REWARDS,
  CONDITIONS,
  CONDITIONAL_REWARDS_TIMER,
  IS_TIME_LIMITED,
} from 'scenes/PromoCodes/constants';

import { conditionRewardValidationSchema } from './ConditionalRewards/schema';
import { rewardValidationSchema } from './Rewards/schema';

const conditionsSchema = object({
  [CONDITIONAL_REWARDS_TIMER]: number()
    .nullable(true)
    .when([IS_TIME_LIMITED], (isTimeLimited, schema) => {
      if (isTimeLimited) {
        return schema
          .min(1, 'Timer must be greater than or equal to 1')
          .required('Completion time is required');
      }
      return schema;
    }),
  [CONDITIONAL_REWARDS]: collection(conditionRewardValidationSchema).max(
    10,
    'Conditional rewards count should be less than or equal 10'
  ),
});

export const promoCodeSchema = object({
  [NAME]: string().required('Name is required'),
  [APPLICATION]: number().required('Application is required'),
  [START_DATE]: date().required('Start date is required'),
  [PROMO_CODE]: string().required('Promo code is required'),
  [ACTIVITY_TYPE]: number().required('Activity type is required'),
  [REWARDS]: collection(rewardValidationSchema).required(
    'Rewards are required'
  ),
  [CONDITIONS]: conditionsSchema,
  [REQUESTED_BY]: number().required('Requested by is required'),
  [JIRA_LINK]: string()
    .url('Jira Task URL must be a valid URL')
    .required('Jira task URL is required'),
});

export const promoCodeSetSchema = promoCodeSchema.shape({
  [NUMBER]: number().required('Number is required'),
});
